import PropTypes from 'prop-types';
import React from 'react';
import { Quote } from '../../quote';
import QuoteView from '../quoteView';
import { Modal } from '@ami/react/core';
import QuoteDiscountFormComponent from './QuoteDiscountFormComponent';
import { QuoteDiscountDocumentViewModel } from '../../QuoteDiscountDocumentViewModel';

export default class QuoteDiscountModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      document: new QuoteDiscountDocumentViewModel(),
    };
  }

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    quoteDiscount: PropTypes.object.isRequired,
    refreshQuote: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func,
  };

  static defaultProps = {
    hideModal: () => null,
  };

  handleOnSubmit = () => {
    const { quote, quoteDiscount } = this.props;
    const { document } = this.state;
    this.setState({ submitting: true });
    Quote.updateQuoteDiscountDocumentation(
      quote.id,
      quoteDiscount.discountId,
      document
    )
      .then(() => {
        this.props.refreshQuote();
        this.props.hideModal();
      })
      .finally(() => this.setState({ submitting: false }));
  };

  hide = () => this.props.hideModal();

  render() {
    const { quoteDiscount } = this.props;
    const { document } = this.state;
    return (
      <Modal
        title="Upload Document"
        show={this.props.showModal}
        showCancel={true}
        onOk={this.handleOnSubmit}
        okTitle="Upload"
        onCancel={this.hide}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        submitting={this.state.submitting}
        closeOnOk={false}
      >
        <QuoteDiscountFormComponent
          quoteDiscount={quoteDiscount}
          document={document}
          onDocumentUpdated={(document) => this.setState({ document })}
        />
      </Modal>
    );
  }
}
